import { useState } from 'react'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { SelectionField } from 'modules/marketplace/hooks/integrations/formQuestions/useGetMarketplaceSettings'

interface SelectionQuestionProps {
  selectionQuestion: SelectionField
  currentValue?: string
  onChange: (value: string | string[]) => void
}

// The backend is already prepared for multiple choice select but not the front
export const SelectionQuestion = ({
  selectionQuestion: { label, required, options, defaultValues, description },
  currentValue,
  onChange,
}: SelectionQuestionProps) => {
  const [value, setValue] = useState<string>(currentValue || defaultValues || '')

  const handleChange = (change: string) => {
    setValue(change)
    onChange(change)
  }

  return (
    <Select
      description={description ? description : undefined}
      value={value}
      none={i18n.t('common.none')}
      label={label}
      options={options}
      onChange={handleChange}
      mandatory={required}
    />
  )
}
